/**
 * blockDomId — derives a DOM-safe anchor id from a block or sub-paragraph id.
 *
 * TASK-009 Phase 5 deliverable #6 ("ancora a blocco"): every rendered block
 * gets an anchorable DOM `id` so fragment deep-links (`#1-1-1-b2`) can scroll
 * to it client-side, without a query param or a server round-trip. Also used
 * for sub-paragraph-level anchors (the same dotted/slashed id shape, just
 * without the trailing `/bN` block suffix) — e.g. the "Ripassa" deep-link
 * from Padronanza, which targets a sub-paragraph, not a specific block.
 *
 * Deterministic, collision-safe for the canonical id alphabet used across the
 * bundle (digits, `.`, `kp`, `compendio`, and the `/bN` block suffix — see
 * outline.ts's canonical id format): every non `[a-zA-Z0-9]` run collapses to
 * a single `-`. `'1.1.1/b2'` -> `'1-1-1-b2'`.
 */
export function blockDomId(id: string): string {
  return id.replace(/[^a-zA-Z0-9]+/g, '-')
}
